<template>
  <mc-sidepanel :active="open" @close="dismiss">
    <template #title>
      <div class="level">
        <div class="title is-5 is-marginless">Update Critic Review</div>
        <b-button
          :loading="challengeAttempts.updating"
          native-type="submit"
          form="criticReviewForm"
          type="is-primary"
          >Update</b-button
        >
      </div>
    </template>
    <template #default>
      <form
        id="criticReviewForm"
        class="critic-review__form section"
        @submit.prevent="updateCriticReviewHandler"
      >
        <b-loading :active="challengeAttempts.updating" :is-full-page="false" />
        <fragment v-for="criterion in criteria" :key="criterion.key">
          <div class="critic-review__form__item">
            <p class="title is-6">{{ criterion.description }}</p>
            <div class="level">
              <div class="level-left">
                <mc-challenge-rating-input
                  v-model="newCriticReview.ratings[criterion.key]"
                  label="Your Rating:"
                  custom-label-class="is-small"
                />
              </div>
              <div class="level-right">
                <mc-challenge-rating-input
                  v-model="selfReview.ratings[criterion.key]"
                  label="User's Rating:"
                  custom-label-class="is-small"
                  disabled
                />
              </div>
            </div>
            <b-field label="User's Comment:" custom-class="is-small">
              <p class="subtitle is-6">
                {{ selfReview.comments[criterion.key] || 'no comments' }}
              </p>
            </b-field>
            <b-field label="Your Comment:" custom-class="is-small">
              <b-input
                v-model="newCriticReview.comments[criterion.key]"
                required
                type="textarea"
              ></b-input>
            </b-field>
          </div>
          <hr />
        </fragment>
        <div class="critic-review__form__item">
          <p class="title is-6">Is the submission worth any Bonus Points?</p>
          <b-field label="Bonus Rating:" custom-class="is-small">
            <b-numberinput
              v-model="newCriticReview.ratings['bonus']"
              required
              min="0"
              step="1"
              :max="totalWeigth * 2"
            ></b-numberinput>
          </b-field>
          <b-field label="Bonus Comment:" custom-class="is-small">
            <b-input
              v-model="newCriticReview.comments['bonus']"
              :required="newCriticReview.ratings['bonus'] !== 0"
              type="textarea"
            ></b-input>
          </b-field>
        </div>
        <hr />
        <div class="critic-review__form__item">
          <b-field label="Any overall comment:" custom-class="is-small">
            <b-input v-model="newOverallComment" type="textarea"></b-input>
          </b-field>
        </div>
      </form>
    </template>
  </mc-sidepanel>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const getEmptyReview = () => {
  return {
    ratings: {},
    comments: {}
  };
};

export default {
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      newCriticReview: getEmptyReview(),
      newOverallComment: ''
    };
  },
  computed: {
    ...mapState(['challengeAttempts', 'challenges']),
    reviews() {
      return this.challengeAttempts.selected.reviews;
    },
    criteria() {
      return this.challenges.selected.details.criteria;
    },
    selfReview() {
      return this.reviews['self'];
    },
    criticReview() {
      return this.reviews['critic'];
    },
    overallComment() {
      return this.challengeAttempts.selected.overallComment;
    },
    totalWeigth() {
      return this.criteria.reduce(
        (sum, criterion) => sum + criterion.weight,
        0
      );
    }
  },
  created() {
    // This is beig done in created because we don't want the dynamic update on the challenge attempt
    // update the review when it is being edited.
    const criticReview = this.criticReview || getEmptyReview();
    this.newCriticReview = {
      ratings: this.criteria.reduce(
        (result, criterion) => {
          result[criterion.key] = criticReview.ratings[criterion.key];
          return result;
        },
        { bonus: criticReview.ratings['bonus'] || 0 }
      ),
      comments: this.criteria.reduce(
        (result, criterion) => {
          result[criterion.key] = criticReview.comments[criterion.key] || '';
          return result;
        },
        { bonus: criticReview.comments['bonus'] || '' }
      )
    };
    this.newOverallComment = this.overallComment;
  },
  methods: {
    ...mapActions('challengeAttempts', ['updateCriticReview']),
    async updateCriticReviewHandler() {
      await this.updateCriticReview({
        criteria: this.criteria,
        criticReview: this.newCriticReview,
        overallComment: this.newOverallComment
      });
      this.$emit('input');
      this.$emit('close');
    },
    dismiss() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.critic-review {
  width: auto;

  &__form {
    @include tablet {
      min-width: 40rem;
    }
    hr {
      background-color: darkgrey;
      margin: 1rem 0;
    }

    &__item {
      width: auto;
      padding: 0 0.7rem;
    }
  }
}
</style>
